import { render, staticRenderFns } from "./MatchTable.vue?vue&type=template&id=649df316&scoped=true&"
import script from "./MatchTable.vue?vue&type=script&lang=js&"
export * from "./MatchTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchTable.vue?vue&type=style&index=0&id=649df316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649df316",
  null
  
)

export default component.exports